import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const BreadcrumbSeparatorIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M10 5L15 12L10 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default BreadcrumbSeparatorIcon;